import log from '@/logger';
import { checkResponseForMaintenance, checkResponseForTaxInfo, checkResponseVersion, checkResponseForDocumentUpload } from './utils';

export default (response) => {
  checkResponseForMaintenance(response);
  checkResponseForTaxInfo(response);
  checkResponseForDocumentUpload(response);
  checkResponseVersion(response);
  log.info('API - SUCCESS', response.status, response.config.method, response.config.url, response);
  return response;
};



// WEBPACK FOOTER //
// ./src/services/interceptors/responseSuccess.js